import * as React from "react";

type PrivacyShieldIconProps = {
  className?: string;
};

export default function PrivacyShieldIcon({ className }: PrivacyShieldIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M8 1.667L13 3.889V7.222C13 10.317 10.867 13.056 8 13.778C5.133 13.056 3 10.317 3 7.222V3.889L8 1.667Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.667L7.5 8.667L9.833 6.333"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
